import { loadFolders, getTodoFolderById, getTodoFoldersLoadState } from 'owa-todo-folders';
import { getProject } from 'owa-timestream-store';
import {
    fetchAndSubscribeToTasks,
    patchProjectTaskFolderId,
    updateLegacyTasksFolderName,
} from '../index';
import type { ProjectId } from 'owa-timestream-types';

export default async function initializeTasks(projectId: ProjectId) {
    const { name, tasksParentFolderId } = getProject(projectId);
    if (!tasksParentFolderId) {
        return;
    }

    let taskFolder = getTodoFolderById(tasksParentFolderId);
    if (!taskFolder) {
        // fetch folders and re-check folderId in cases where the original folders aren't found
        await loadFolders();
        taskFolder = getTodoFolderById(tasksParentFolderId);
    }

    if (!!taskFolder) {
        await fetchAndSubscribeToTasks(tasksParentFolderId);
        updateLegacyTasksFolderName(tasksParentFolderId, taskFolder.Name, name);
    } else if (getTodoFoldersLoadState() === 'Loaded' && !taskFolder) {
        await patchProjectTaskFolderId(projectId, '');
    }
}
